import { Component, OnInit } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { JsVendorContact } from 'src/app/layout/models/layout-model';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { EnvironmentconfigService } from 'src/app/shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';

@Component({
  selector: 'app-account-info',
  templateUrl: './account-info.component.html',
  styleUrls: ['./account-info.component.scss']
})
export class AccountInfoComponent implements OnInit {
  isLoading = true;
  showVendorInfo = false;
  displayVendorInfo: JsVendorContact[] = [];
  accountInfo: {
    loginAccount?: string,
    accountUser?: string,
    accountEmail?: string
  } = {};
  constructor(private auth: AuthService,
    private webApiServ: WebApiService,
    private envServ: EnvironmentconfigService,
    private msgService: NzMessageService
  ) { }

  ngOnInit(): void {
    this.setAccountInfo();
    this.setVendorInfo();
  }


  setAccountInfo() {
    const userInfo = this.auth.getCurrentUserInfo();
    this.accountInfo = {
      loginAccount: userInfo.userId,
      accountUser: userInfo.displayName,
      accountEmail: userInfo.email
    };
  }
  setVendorInfo() {
    this.isLoading = true;
    this.showVendorInfo = false;
    this.displayVendorInfo = [];
    const userInfo = this.auth.getCurrentUserInfo();
    if (userInfo.userType !== 'User' && userInfo.email) {
      const url = `${this.envServ.authConfig.MVMBackEnd}${URLConst.QueryVendorContact.url}`;
      this.webApiServ.doPost(url, { email: userInfo.email, userType: userInfo.userType }, false, true).subscribe(res => {
        if (res.rc === 0) {
          if (res.data && res.data.length > 0) {
            //忽略siteNo,siteName,companyCode欄位,只按其他欄位去重
            const uniqueData = res.data.filter((item, index, self) =>
              index === self.findIndex((t) => (
                t.vendorCode === item.vendorCode &&
                t.vendorName === item.vendorName &&
                t.vendorAddress === item.vendorAddress &&
                t.contactPerson === item.contactPerson &&
                t.contactMobile === item.contactMobile &&
                t.contactEmail === item.contactEmail
              ))
            );
            this.displayVendorInfo = uniqueData;

            this.showVendorInfo = true;
            this.isLoading = false;
          }
        } else {
          this.msgService.error(res.msg || 'System Error');
          this.showVendorInfo = false;
          this.isLoading = false;
        }
      });
    } else {
      this.isLoading = false;
      this.showVendorInfo = false;
    }
  }
}
